<div class="footer-container font-inter">
    <div class="footer-content container">
        <div class="top-section">
            <div class="section">
                <a class="logo-container" routerLink="/home">
                    <img src="../../../assets/images/funfigz-logo.png" class="logo-image" alt="Logo" />
                </a>

                <p class="description">Building imagination, one block at a time. Quality toys for creative minds.</p>
                <div class="icon-collection">
                    <div class="icon-container">
                        <mat-icon [svgIcon]="'fb'" class="social-icon"></mat-icon>
                    </div>
                    <div class="icon-container">
                        <mat-icon [svgIcon]="'ig'" class="social-icon"></mat-icon>
                    </div>
                    <div class="icon-container">
                        <mat-icon [svgIcon]="'utube'" class="social-icon"></mat-icon>
                    </div>
                    <div class="icon-container">
                        <mat-icon [svgIcon]="'pin'" class="social-icon"></mat-icon>
                    </div>
                </div>
            </div>

            <div class="shop-section">
                <p class="shop-title font-poppins">Shop</p>
                <a class="item" routerLink="/products">All Products</a>
                <a class="item">Best Sellers</a>
                <a class="item">New Arrivals</a>
                <a class="item">Special Offers</a>
            </div>

            <div class="support-section">
                <a class="support-title font-poppins">Support</a>
                <a class="item" routerLink="/contact">Contact Us</a>
                <a class="item">FAQs</a>
                <a class="item">Shipping Info</a>
                <a class="item">Returns</a>
            </div>

            <div class="company-section">
                <p class="company-title font-poppins">Company</p>
                <a class="item" routerLink="/about-us">About Us</a>
                <a class="item">Our Story</a>
                <a class="item">Safety Standards</a>
                <a class="item">Blog</a>
            </div>
        </div>

        <div class="separator"></div>

        <div class="bottom-section">
            <span class="copyright">
                <mat-icon
                    aria-hidden="false"
                    aria-label="copyright icon"
                    fontIcon="copyright"
                    class="copyright-icon"
                ></mat-icon>
                {{ currentYear }} FunFigz. All rights reserved.
            </span>

            <span class="payment">
                <span>We Accept:</span>
                <span class="payment-icons-collection">
                    <mat-icon [svgIcon]="'visa'" class="payment-icon"></mat-icon>
                    <mat-icon [svgIcon]="'mastercard'" class="payment-icon"></mat-icon>
                    <mat-icon [svgIcon]="'paypal'" class="payment-icon"></mat-icon>
                </span>
            </span>
        </div>
    </div>
</div>
